import { Home } from "lucide-react";
import React from "react";

import styles from "./NotFoundStyles";
import "../../../layouts/styles.css";
import { useHistory } from "react-router-dom";

const NotFound = () => {
  const classes = styles();
  const history = useHistory();

  return (
    <div className="container">
      <div className="main-content">
        <div className={classes.root}>
          <h1 className={classes.headerText}>404</h1>
          <p className={classes.description}>Page not found</p>
          <Home className={classes.home} onClick={() => history.push("/")}>
            Go back to homepage
          </Home>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
